export let ApprovalStatus;
(function (ApprovalStatus) {
  ApprovalStatus["APPROVAL_PENDING"] = "APPROVAL_PENDING";
  ApprovalStatus["APPROVED"] = "APPROVED";
  ApprovalStatus["CANCELLED"] = "CANCELLED";
  ApprovalStatus["REJECTED"] = "REJECTED";
})(ApprovalStatus || (ApprovalStatus = {}));